import { defineStore } from 'pinia';

export interface DashboardConfigs {
    urlFiltersAllowed: Record<string, { format: (value: string) => string | string[] }>;
    hotSwapDate: string | null;
    currentView: {
        hotSwapDate: string | null;
    };
    dates: any[];
    columnVisibilities: Record<string, string>;
    columnOrder: string[];
    columns: Array<{ name: string; visible: boolean }>;
    filters: Record<string, any>;
    order: {
        orderBy: string;
        sortBy: string;
    };
    expanded: Record<string, boolean>;
    options: Record<string, boolean>;
}

interface DashboardContextState {
    configs: DashboardConfigs;
    startDate: string | null;
    endDate: string | null;
    dashboardType: string;
}

export const buildDashboardDefaultConfigs = (): DashboardConfigs => ({
    urlFiltersAllowed: {
        campaigns: { format: (value) => value.split(',') },
        campaigns_sent: { format: (value) => value },
        campaigns_delivered: { format: (value) => value },
        campaigns_opened: { format: (value) => value },
        campaigns_clicked: { format: (value) => value },
        campaigns_replied: { format: (value) => value },
        campaigns_objective_reached: { format: (value) => value },
        status: { format: (value) => value.split(',') },
        result: { format: (value) => value.split(',') },
        contact_method: { format: (value) => value.split(',') },
        'division:name': { format: (value) => value.split(',') },
        'lead_type:name': { format: (value) => value.split(',') },
        assignees: { format: (value) => value.split(',') },
    },
    hotSwapDate: null,
    currentView: { hotSwapDate: null },
    dates: [],
    columnVisibilities: {},
    columnOrder: [],
    columns: [],
    filters: {},
    order: { orderBy: 'fullname', sortBy: 'asc' },
    expanded: {
        leadTable: true,
        saleProfit: false,
        saleTable: false,
        statsByAgent: true,
        tradeReport: false,
        userTable: false,
        statsTable: false,
    },
    options: {
        carryOver: true,
        doubleWalkIn: false,
        endContractStats: false,
        includeAttributions: false,
        phoneAppointment: false,
        recordedDate: false,
        resultStats: false,
        showAgent: true,
        showAllLeads: false,
        showStats: true,
        otherVisit: false,
        lostDate: false,
    },
});

export const useDashboardContextStore = defineStore('dashboardContext', {
    state: (): DashboardContextState => ({
        configs: buildDashboardDefaultConfigs(),
        startDate: null,
        endDate: null,
        dashboardType: '',
    }),

    actions: {
        setStartDate(date: string | null) {
            this.startDate = date;
        },
        setEndDate(date: string | null) {
            this.endDate = date;
        },
        setDashboardType(type: string) {
            this.dashboardType = type;
        },
        setConfigs(configs: Partial<DashboardConfigs>) {
            this.configs = { ...this.configs, ...configs };
        },
        resetConfigs() {
            this.configs = buildDashboardDefaultConfigs();
        },
    },
});
